module.exports = __webpack_public_path__ + "img/Support-skill-231.901170fd.png";